module.exports = __webpack_public_path__ + "static/media/smart_search_facial_icon.020ecf6f.png";